<div class="base">
    <div class="contenedor" id="contenedor">
        <div class="contenido">
            <div class="loader">
            </div>
            <p class="offline">
                Sesión fuera de línea!
            </p>
        </div>
    </div>
</div>